


    const customSelects = document.querySelectorAll('.custom-select');

    customSelects.forEach(select => {
    const selectedOption = select.querySelector('.selected-option');
    const options = select.querySelectorAll('.option');

    selectedOption.addEventListener('click', () => {
        select.classList.toggle('open');
    });

    options.forEach(option => {
        option.addEventListener('click', () => {
        const img = option.querySelector('img');
        const text = option.querySelector('span').textContent;
        selectedOption.innerHTML = '';
        selectedOption.appendChild(img.cloneNode(true));
        selectedOption.insertAdjacentHTML('beforeend', `<span>${text}</span>`);
        select.classList.remove('open');
        });
    });
    });

function setCookie(cname, cvalue, exdays) {
    var d = new Date();
    d.setTime(d.getTime() + (exdays*24*60*60*1000));
    var expires = "expires="+ d.toUTCString();
    document.cookie = cname + "=" + cvalue + ";" + expires + ";path=/;domain=dartscorner.co.uk";
  
    document.cookie = cname + "=" + cvalue + ";" + expires + ";path=/;domain=dartscorner.de";
  
    document.cookie = cname + "=" + cvalue + ";" + expires + ";path=/;domain=dartscorner.nl";
}

function getCookie(cname) { 
    var name = cname + "=";
    var decodedCookie = decodeURIComponent(document.cookie);
    var ca = decodedCookie.split(';');
    for(var i = 0; i <ca.length; i++) {
      var c = ca[i];
      while (c.charAt(0) == ' ') {
        c = c.substring(1);
      }
      if (c.indexOf(name) == 0) {
        return c.substring(name.length, c.length); 
      }
    }
    return ""; 
}


function geoLocation() {

    var storePreference = localStorage.getItem('storePreferenceValue'),
        stayOnStorePreference = getCookie("stayOnStore"),
        cookieStorePreference = getCookie("cookieStorePreferenceNew");
        console.log("checking cookie preferences");
  console.log(storePreference);
    console.log(stayOnStorePreference);
    console.log(cookieStorePreference);

        storeAddress = $('.store-redirect').attr('data-store-address'),
        redirectPopup = $('.redirect-popup'),
        redirectOverlay = $('.redirect-overlay'),
        redirectTargetCountry = $('.target-country'),
        redirectButtonLink = $('.btn-redirect'),
        
        URLPath = window.location.pathname;

    // If customer has not clicked 'Stay on Store' or changed site in site select.
     
  console.log(stayOnStorePreference);
   console.log(cookieStorePreference);
    if (stayOnStorePreference == "") {
      
        if (cookieStorePreference == "") {
             console.log('preference not set');

            $.ajax({
                url: '//api.ipstack.com/check?access_key=712633c3a540ea1315dc67f653d57395',
                dataType: 'json',
                 async: false,
                success: function (json) {

                    //If customer is from US
                  console.log(json.country_code);
                     if (json.country_code == "US") {
                        //If customer is from UK
                        //Check to see if store is also UK
                        if (storeAddress === 'dartscorner.com') {
                            //If customer and store are both UK, do nothing. They are were they are supposed to be.
                            //set user store preference
                            setCookie("cookieStorePreferenceNew", "US", 365)
                        } else {
                            //show redirect popup - with option to redirect to UK.
                            $(redirectTargetCountry).html('UNITED STATES');
                            $(redirectButtonLink).attr('href', 'https://dartscorner.com' + URLPath);
                            $(redirectPopup).addClass('active');
                            $(redirectOverlay).addClass('active');  
                        }
                    
                    } 
                      
                         else if (json.country_code == "CA") {
                        //If customer is from UK
                        //Check to see if store is also UK
                        if (storeAddress === 'dartscorner.com') {
                            //If customer and store are both UK, do nothing. They are were they are supposed to be.
                            //set user store preference
                            setCookie("cookieStorePreferenceNew", "US", 365)
                        } else {
                            //show redirect popup - with option to redirect to UK.
                            $(redirectTargetCountry).html('Canada');
                            $(redirectButtonLink).attr('href', 'https://dartscorner.com' + URLPath);
                            $(redirectPopup).addClass('active');
                            $(redirectOverlay).addClass('active');  
                        }
                    
                    }

                    else if (json.country_code == "DE") {
                      console.log(window.location.href);
                      console.log("check this boi");
                        //If customer is from UK
                        //Check to see if store is also UK
                      // storeAddress = $('.store-redirect').attr('data-store-address-german');
                        if (window.location.href == 'https://www.dartscorner.de/') {
                            //If customer and store are both UK, do nothing. They are were they are supposed to be.
                            //set user store preference
                            setCookie("cookieStorePreferenceNew", "DE", 365);
                          
                            $(redirectOverlay).addClass('hello');
                          
              $('.redirect-popup').removeClass('active');
              $('.redirect-overlay').removeClass('active');
                          
                          
                        } else {
                            
                            $(redirectTargetCountry).html('Germany');
                            $(redirectButtonLink).attr('href', 'https://www.dartscorner.de' + URLPath);
                            $(redirectPopup).addClass('active');
                            $(redirectOverlay).addClass('active');
                        }
                    
                    }
                      else if (json.country_code == "NL") {
                        //If customer is from UK
                        //Check to see if store is also UK
                         
                        console.log("------ come check this ------------");
                        console.log(window.location.href);
                      //  storeAddress = $('.store-redirect').attr('data-store-address-nethlands');
                        if (window.location.href == 'https://www.dartscorner.nl/'  ) {
                            
                            //If customer and store are both UK, do nothing. They are were they are supposed to be.
                            //set user store preference
                            setCookie("cookieStorePreferenceNew", "NL", 365);
                          
                            $(redirectOverlay).addClass('hello');
                          
              $('.redirect-popup').removeClass('active');
              $('.redirect-overlay').removeClass('active');
                          
                          
                        } else {
                          
                            $(redirectTargetCountry).html('Netherlands');
                            $(redirectButtonLink).attr('href', 'https://www.dartscorner.nl' + URLPath);
                            $(redirectPopup).addClass('active');
                            $(redirectOverlay).addClass('active');
                          
          //  window.top.location.href = "https://www.dartscorner.nl" + URLPath;
                        }
                    
                    }
                       
                     else {
                        // IF Customer is not from any of the above
                        //Check to see if store is INT
                        if (storeAddress === 'dartscorner.co.uk') {
                            //set user store preference
                            setCookie("cookieStorePreferenceNew", "UK", 365)
                           console.log(window.location.href);
                          console.log("testing");
                            // if(window.location.href != "https://www.dartscorner.co.uk/") {
                            //   window.location.href = "https://www.dartscorner.co.uk/";
                            // }
                        } else {                      
                            //show redirect popup - with option to redirect to US.
                           console.log("tttttt");
                            $(redirectTargetCountry).html('EU');
                            $(redirectButtonLink).attr('href', 'https://dartscorner.co.uk' + URLPath);
                            $(redirectPopup).addClass('active');
                            $(redirectOverlay).addClass('active');
                        }
                    }
                }
            });

        //IF store preference is set.   
        
        } else if (cookieStorePreference == "US") {
            console.log('preference:' +cookieStorePreference);

            //IF store preference is UK. 
            if (storeAddress === 'dartscorner.com') {
                // and customer is on UK store. Do nothing. 
              $('.redirect-popup').removeClass('active');
        $('.redirect-overlay').removeClass('active');
            } else {
            }
        } 
      
        else if (cookieStorePreference == "UK") {
            //console.log('preference:' +cookieStorePreference);

            //IF store preference is INT. 
            if (storeAddress === 'dartscorner.co.uk') {
                // and customer is on INT store. Do nothing. 
              $('.redirect-popup').removeClass('active');
              $('.redirect-overlay').removeClass('active');
            } else {
            }
        }
      else if (cookieStorePreference == "de") {
            //console.log('preference:' +cookieStorePreference);

            //IF store preference is INT. 
            if (storeAddress === 'www.dartscorner.de') {
                // and customer is on INT store. Do nothing. 
              $('.redirect-popup').removeClass('active');
              $('.redirect-overlay').removeClass('active');
            } else {
            }
        }
       else if (cookieStorePreference == "nl") {
            //console.log('preference:' +cookieStorePreference);

            //IF store preference is INT. 
            if (storeAddress === 'www.dartscorner.nl') {
                // and customer is on INT store. Do nothing. 
              $('.redirect-popup').removeClass('active');
              $('.redirect-overlay').removeClass('active');
            } else {
            }
        }
      // If customer has set a preference with 'Stay on Store' or changed site in site select and they land on another store - ask if they want to be redirected to their prefered store.
    } else if (stayOnStorePreference == "UK") {
        //IF store preference is US. 
      console.log("sdasdasdasd");
        if (storeAddress === 'dartscorner.co.uk') {
            // and customer is on US store. Do nothing. 
          $('.redirect-popup').removeClass('active');
        $('.redirect-overlay').removeClass('active');
        } else {
            window.top.location.href = "https://www.dartscorner.co.uk" + URLPath;
        }
    } else if (stayOnStorePreference == "US") {
        //IF store preference is UK. 
        if (storeAddress === 'dartscorner.com') {
            // and customer is on UK store. Do nothing. 
          $('.redirect-popup').removeClass('active');
        $('.redirect-overlay').removeClass('active');
        } else {
            window.top.location.href = "https://dartscorner.com" + URLPath;
        }
    } 
  else if (stayOnStorePreference == "de") {
        //IF store preference is UK. 
        if (storeAddress === 'dartscorner.de') {
            // and customer is on UK store. Do nothing. 
          $('.redirect-popup').removeClass('active');
        $('.redirect-overlay').removeClass('active');
        } else {
            window.top.location.href = "https://dartscorner.de" + URLPath;
        }
    } 
  else if (stayOnStorePreference == "nl") {
        //IF store preference is UK. 
        if (storeAddress === 'dartscorner.nl') {
            // and customer is on UK store. Do nothing. 
          $('.redirect-popup').removeClass('active');
        $('.redirect-overlay').removeClass('active');
        } else {
            window.top.location.href = "https://dartscorner.nl" + URLPath;
        }
    } 
}

function countrySelectChange() {
    var link = $('.country-select a');
    link.on("click", function(e){
        e.preventDefault(); 

        var value = $(this).text(),
            drophref = $(this).attr('href'); 

        if (value == "US") {
            //localStorage.setItem('storePreferenceValue', 'US');
            setCookie("cookieStorePreferenceNew", "US", 365)
            setCookie("stayOnStore", "US", 365)
            //console.log('preference set US');
            window.top.location.href = drophref; 
        } else if (value == "UK") {
            //localStorage.setItem('storePreferenceValue', 'UK');
            setCookie("cookieStorePreferenceNew", "UK", 365)
            setCookie("stayOnStore", "UK", 365)
            //console.log('preference set UK');
            window.top.location.href = drophref; 
        } else if (value == "NL") {
            //localStorage.setItem('storePreferenceValue', 'FR');
            setCookie("cookieStorePreferenceNew", "NL", 365)
            setCookie("stayOnStore", "NL", 365)
            //console.log('preference set FR');
            window.top.location.href = drophref; 
        } else if (value == "CA") {
            //localStorage.setItem('storePreferenceValue', 'FR');
            setCookie("cookieStorePreferenceNew", "CA", 365)
            setCookie("stayOnStore", "CA", 365)
            //console.log('preference set FR');
            window.top.location.href = drophref; 
        } else if (value == "DE") {
            //localStorage.setItem('storePreferenceValue', 'DE');
            setCookie("cookieStorePreferenceNew", "DE", 365)
            setCookie("stayOnStore", "DE", 365)
            //console.log('preference set DE');
            window.top.location.href = drophref; 
        } else if (value == "EU") {
            //localStorage.setItem('storePreferenceValue', 'EU');
            setCookie("cookieStorePreferenceNew", "EU", 365)
            setCookie("stayOnStore", "EU", 365)
            //console.log('preference set EU');
            window.top.location.href = drophref; 
        } else if (value == "INT") {
            //localStorage.setItem('storePreferenceValue', 'INT');
            setCookie("cookieStorePreferenceNew", "INT", 365)
            setCookie("stayOnStore", "INT", 365)
            //console.log('preference set INT');
            window.top.location.href = drophref; 
        }
    })
}


function redirectClose() {
    $('.redirect-close').off('click').on('click', function(){

        var storeAddress = $('.store-redirect').attr('data-store-address');
      

        $('.redirect-popup').removeClass('active');
        $('.redirect-overlay').removeClass('active');

         if (storeAddress.indexOf('us') >= 0) {
            setCookie("cookieStorePreferenceNew", "US", 365)
            setCookie("stayOnStore", "US", 365)
        } else if (storeAddress === 'dartscorner.co.uk') {
            setCookie("cookieStorePreferenceNew", "UK", 365)
            setCookie("stayOnStore", "UK", 365)
         }else if (storeAddress === 'dartscorner.de') {
            setCookie("cookieStorePreferenceNew", "de", 365)
            setCookie("stayOnStore", "DE", 365)
         }else if (storeAddress === 'dartscorner.nl') {
            setCookie("cookieStorePreferenceNew", "nl", 365)
            setCookie("stayOnStore", "NL", 365)
         }
    });
}

function redirectCheck() {
   var storeRedirect = $('.store-redirect'); 
  
   if (storeRedirect.length) {
       geoLocation();
       redirectClose();
       countrySelectChange();
   }
}

$('#close-popup').click(function(){
 
  $("#popup-content").attr("style","display:none!important");
})

redirectCheck();

